import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const CabinType = ({ cabinType }: SpecProps<"cabin_type">) => {
  const { i18n } = useLingui();

  if (!cabinType) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.cabinType",
    message: "Cabin type",
    comment: "Field for 'Cabin type' for truck and bus in ad specification",
  });

  return <FieldValuePair field={field} value={cabinType.value} />;
};
